const itemsData = {
  Id: 0,
  boxLines: [
    {
      rowList: [
        { title: "付汇单号:  ", banding: "Code", value: "FH23423423", className: "c-code-color" },
        { title: "单号: ", banding: "OrderNos", value: "A00056", className: "c-common-color" }
      ]
    },
    {
      rowList: [
        {
          title: "申请付汇金额: ",
          banding: "LastPaymentAmount",
          value: "2000",
          className: "c-amount-color"
        },
        { title: "人民币金额: ", banding: "SCAmount", value: "2000", className: "c-unAmount-color" }
      ]
    },
    {
      rowList: [
        { title: "币制: ", banding: "CurrencyType", value: "RMB" },
        { title: "汇率: ", banding: "SettlementRate", value: "7.6" }
      ]
    },
    {
      rowList: [
        { title: "申请日期: ", banding: "SettlementDay", value: "2020-06-20", dataType: "Date" },
        { title: "付汇日期: ", banding: "RealSettlementDay", value: "2020-06-20", dataType: "Date" }
      ]
    },
    {
      rowList: [
        { title: "收款人: ", banding: "SupplierName", value: "测试收" },
        { title: "账户名称: ", banding: "TT_AccountName", value: "4564564645465" }
      ]
    },

    {
      rowList: [
        {
          title: "审核状态: ",
          banding: "Status",
          value: "",
          dataType: "Type",
          dataMap: {
            0: "未提交",
            1: "待审核",
            2: "已审核",
            4: "已退回"
          },
          classMap: {
            0: "c-unSumbit-color",
            1: "c-unAudit-color",
            2: "c-audit-color",
            4: "c-back-color"
          }
        },
        {
          title: "结算类型:   ",
          banding: "SettlementMode",
          value: "",
          dataType: "Type",
          dataMap: { 1: "T.T(转账)", 2: "COD(支票结算)", 3: "不付货款", 4: "其他方式" },
          classMap: { 1: "c-one-color ", 2: "c-two-color", 3: "c-three-color", 4: "c-four-color" }
        }
      ]
    }
  ]
};
const itemsDetailData = {
  boxLines: [
    {
      rowList: [
        { title: "订单号:  ", banding: "OrderNo", value: "", className: 'c-code-color' },
        { title: "本次付汇金额:  ", banding: "LastPaymentAmount", value: "" },
        { title: " ", banding: "", value: "" }
      ]
    },
    {
      rowList: [
        { title: "订单金额:  ", banding: "PaymentAmount", value: "", className: 'c-amount-color' },
        { title: "订单币别:  ", banding: "CurrencyType", value: "" },
        { title: "可付汇金额:  ", banding: "RemainingPaymentAmount", value: "", className: 'c-unAmount-color' }
      ]
    }
  ]
};
export { itemsData, itemsDetailData };
